<template>
  <div
    class="items-center"
    :class="{'flex flex-wrap -mx-4': !isMobile}"
  >
    <div class="w-full lg:w-7/12 px-4">
      <slot
        v-if="isMobile"
        name="bars-mobile"
      />
      <slot
        v-else
        name="bars-desktop"
      />
    </div>

    <div class="w-full lg:w-5/12 px-4 self-center">
      <div class="flex flex-wrap -mx-4">
        <slot name="controls" />
      </div>
    </div>

    <slot name="rates" />
  </div>
</template>

<script setup lang="ts">
import { useDetectMobile } from "@/application/composables/detectMobile";

const { isMobile } = useDetectMobile();
</script>
